import React from "react";
var __jsx = React.createElement;
import ImageSlider from './ImageSlider';
function ImageSliderAdapter(_ref) {
  var entry = _ref.entry;
  return __jsx(ImageSlider, {
    imageSliderData: entry
  });
}
export default ImageSliderAdapter;